._section_pqh0c_1 {
  padding-bottom: 19px;
  margin-top: 12px; }

._items_pqh0c_5 {
  border: 3px solid rebeccapurple;
  position: relative;
  height: 100px;
  margin: 20px; }
